<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <div v-if="loader && !dashboard" class="text-center">
      <Loader
        :size="'big'"
      />
    </div>

    <!-- begin: metabase content -->
    <template v-if="showMetabaseDashboard">
      <iframe :src="metabaseDashboardUrl" height="4210" width="100%"></iframe>
    </template>
    <!-- end: metabase content -->

    <div v-else-if="user && dashboard">
      <div class="d-flex justify-content-between align-items-center mt-5 mb-10">
        <!--begin::Page title-->
        <div class="d-flex text-uppercase text-center justify-content-center align-items-center gap-3">
          <BaseIcon size="small">
            <ReportIcon />
          </BaseIcon>
          <h1 class="highlighted-color1">
            <span>{{ dashboard.name }}</span>
          </h1>
        </div>
        <router-link :to="{ name: 'dashboards.index' }" class="btn btn-color9">{{ $t('back') }}</router-link>
      </div>
      <!-- DASHBOARD -->
      <div>
        <!-- EXTERNAL -->
        <template v-if="dashboard.type === 'EXTERNAL'">
          <!-- LOOKER -->
          <div v-if="dashboard.platform === 'LOOKER_STUDIO'">
            <iframe class="dashboard-iframe" :src="dashboard.embed_url" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div> <!-- END LOOKER -->
          <!-- SPREADSHEET -->
          <div v-if="dashboard.platform === 'SPREADSHEET'">
            <div class="d-flex">
              <div class="col-6">
                <h2 class="mb-4">Link do Spreadsheets (PixelMetrics)</h2>
                <a :href="'https://docs.google.com/spreadsheets/d/'+dashboard.platform_id" target="_blank" rel="noopener noreferrer" class="btn btn-color1">Clique aqui</a>
              </div>
              <div class="col-lg-4">
                <h2 class="m-0 text-gray-900 flex-grow-1">PixelMetrics</h2>
                <small>Está atualização pode levar de 15 a 30 minutos.</small>
                <div class="mt-3" v-if="dashboard.advertiser">
                  <RefreshPixelMetricsButton
                    :advertiserId="dashboard.advertiser.id"
                  />
                </div>
                <div class="mt-3" v-else>
                  <RefreshPixelMetricsButton
                    :companyId="dashboard.company.id"
                  />
                </div>
              </div>
            </div>
          </div> <!-- END SPREADSHEET -->
        </template><!-- END EXTERNAL -->
      </div> <!-- END DASHBOARD -->
    </div>
  </MainLayout>
</template>

<script>

import DashboardsService from '@/modules/dashboards/services/dashboards-service'
import { mapState } from 'vuex'

import BaseIcon from '@/components/common/Icon/BaseIcon'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'
import RefreshPixelMetricsButton from '@/components/integrations/RefreshPixelMetricsButton'
import ReportIcon from '@/components/common/Icon/ReportIcon'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'

export default {
  components: {
    BaseIcon,
    Loader,
    MainLayout,
    ReportIcon,
    RefreshPixelMetricsButton,
    Shortcuts
  },
  data () {
    return {
      dashboard: null,
      loader: false
    }
  },
  metaInfo () {
    return {
      title: this.dashboard ? this.dashboard.name : ''
    }
  },
  created () {
    if (!this.showMetabaseDashboard) {
      this.getDashboard()
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    metabaseDashboardUrl () {
      if (this.showMetabaseDashboard) {
        return `${process.env.VUE_APP_METABASE_DASH_URL}/${this.$route.params.id}#background=false&bordered=false&titled=false`
      }
      return null
    },
    /**
     * Get route to decide which dashboard to show
     */
    showMetabaseDashboard () {
      return this.routeName === 'dashboards.advertiser.show'
    },
    /**
     * Router name
     */
    routeName () {
      return this.$route.name
    }
  },
  methods: {
    /**
     * Get dashboard
     */
    async getDashboard () {
      this.loader = true
      try {
        const dashboard = await DashboardsService.getDashboard(this.$route.params.id)
        this.dashboard = dashboard
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
        this.$router.push('/')
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .dashboard-iframe {
    width: 100%;
    height: 180vh;
  }
</style>
